import { sectionNames } from "@saleor/intl";
import { asSortParams } from "@saleor/utils/sort";
import { parseQueryString } from "@saleor/utils/urls";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation, useParams } from "react-router-dom";

import { WindowTitle } from "../components/WindowTitle";
import {
  PageListUrlQueryParams,
  PageListUrlSortField,
  PageUrlQueryParams
} from "./urls";
import PageCreate from "./views/PageCreate";
import PageDetailsComponent from "./views/PageDetails";
import PageListComponent from "./views/PageList";

const PageList: React.FC = () => {
  const location = useLocation();
  const qs = parseQs(location.search.substr(1));
  const params = asSortParams(
    qs,
    PageListUrlSortField,
    PageListUrlSortField.title
  ) as PageListUrlQueryParams;
  return <PageListComponent params={params} />;
};

const PageDetails: React.FC = () => {
  const location = useLocation();
  const { id } = useParams();
  const params = parseQueryString<PageUrlQueryParams>(
    location.search.substr(1)
  );

  return <PageDetailsComponent id={decodeURIComponent(id)} params={params} />;
};

const Component = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.pages)} />
      <Routes>
        <Route path={""} element={<PageList />} />
        <Route path={"add"} element={<PageCreate />} />
        <Route path={":id"} element={<PageDetails />} />
      </Routes>
    </>
  );
};

export default Component;
